module.exports = __webpack_public_path__ + "img/FRK-alt.44c3b772.svg";